module.exports = __webpack_public_path__ + "img/ztl-hov.3d3c6e8f.png";